module.exports = __webpack_public_path__ + "static/media/graphic.450443b5.svg";